<template>
<div class="chapter">
<div class="inner_page">
<p><span class="calibre3"><br class="calibre4" id="calibre_pb_1"/></span></p>
<div class="Section2">
<br/>
<br/>
<p class="MsoNormal"><i class="calibre5"><span class="calibre1">For Jim, who never gives up on me, even when I'm at my worst.</span></i></p>
<p class="MsoNormal"><i class="calibre5"><span class="calibre1">For Brian and Jamie, who love me for myself.</span></i></p>
<p class="MsoNormal"><i class="calibre5"><span class="calibre1">And, for Mrs. Traina, whose friendship has introduced me to possibilities within myself that I had not seen.</span></i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Tempted03.vue?1304836c